import { Link } from "react-router-dom";
import { SITE_NAME, COLUMNS } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-auto border-t border-background-300/60 bg-background-100">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:px-6 sm:grid-cols-2 lg:grid-cols-4">
        <div className="sm:col-span-2 lg:col-span-1">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label={SITE_NAME}>
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-base text-background-50">
              <i className="ri-chat-smile-3-line" aria-hidden="true" />
            </span>
            <span className="font-heading text-lg font-black text-foreground-950">{SITE_NAME}</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-6 text-foreground-600">
            汇集校园里的恋爱故事、表白现场与分手内幕，最新现场直击，天天更新。理性吃瓜，温柔围观。
          </p>
        </div>

        <nav aria-label="栏目导航" className="text-sm">
          <h4 className="mb-3 text-sm font-bold text-foreground-900">栏目速递</h4>
          <ul className="space-y-2.5">
            {COLUMNS.map((c) => (
              <li key={c.slug}>
                <Link to={`/column/${c.slug}`} className="inline-flex items-center gap-1.5 text-foreground-600 transition-colors hover:text-primary-700">
                  <i className="ri-arrow-right-s-line text-primary-400" aria-hidden="true" />
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="网站导航" className="text-sm">
          <h4 className="mb-3 text-sm font-bold text-foreground-900">快捷入口</h4>
          <ul className="space-y-2.5">
            <li><Link to="/" className="text-foreground-600 transition-colors hover:text-primary-700">首页 · 最新瓜料</Link></li>
            <li><Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-700">关于我们</Link></li>
            <li><a href="#faq" className="text-foreground-600 transition-colors hover:text-primary-700">吃瓜守则 FAQ</a></li>
            <li><a href="#hot" className="text-foreground-600 transition-colors hover:text-primary-700">热度排行榜</a></li>
          </ul>
        </nav>

        <div className="text-sm">
          <h4 className="mb-3 text-sm font-bold text-foreground-900">联系我们</h4>
          <ul className="space-y-2.5 text-foreground-600">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-500" aria-hidden="true" /> hello@daxuechigua.example
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-500" aria-hidden="true" /> 每日 08:00 - 24:00 更新
            </li>
          </ul>
          <p className="mt-4 rounded-lg bg-background-50 px-3 py-2 text-xs leading-5 text-foreground-500">
            本站内容均来自公开网络信息或网友投稿，仅供娱乐交流，请理性看待。
          </p>
        </div>
      </div>

      <div className="border-t border-background-300/60">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {year} {SITE_NAME}. 内容仅供娱乐，请理性吃瓜。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-primary-500" aria-hidden="true" />
            新瓜不断 · 欢迎围观
          </p>
        </div>
      </div>
    </footer>
  );
}